const pathnames = {
	login: "/",
	accountSuspended: "/account-suspended",
	dashboard: "/dashboard",

	orders: "/orders",

	maintenance: "/maintenance",

	userManagement: {
		admins: "/user-management/admins",
		employee: "/user-management/employee/",
		employees: "/user-management/employees",
		amendmentStatus: "/user-management/amendment-status",
	},

	companyBenefits: {
		benefits: "/company-benefits/benefits",
		benefit: "/company-benefits/benefit/",
		positions: "/company-benefits/positions",
	},

	setup: {
		setup: "/setup/setup",
		setupCoverages: "/setup/coverages",
	},

	leaveManagement: {
		leaves: "/leave-management/leaves",
		leave: "/leave-management/leave/",
		leaveDirectory: "/leave-management/leave-directory",
		leavesApproval: "/leave-management/leaves-approval",
		allLeave: "/leave-management/all-leave",
		holidayCalendars: "/leave-management/holiday-calendars",
		holidayCalendar: "/leave-management/holiday-calendars/",
	},

	overtimeManagement: {
		overtimeApproval: "/overtime-management/overtime-approval",
		overtimeHistory: "/overtime-management/overtime-history",
	},

	claimManagement: {
		claim: "/claim-management/claim/",
		claimDirectory: "/claim-management/claim-directory",
		claimApproval: "/claim-management/claim-approval",
		companyClaimHistory: "/claim-management/company-claim-history",
	},

	insuranceCoverage: {
		claim: "/insurance-coverage/claim",
		selectClaimType: "/insurance-coverage/select-claim-type",
		uploadClaimDocuments: "/insurance-coverage/upload-claim-documents",
		policy: "/insurance-coverage/policy",
		coverages: "/insurance-coverage/coverages",
	},

	appointmentSession: {
		pageAppointmentSession: "/appointment/page-appointment",
	},

	eLearning: {
		course: "/e-learning/course",
		ongoingAssignment: "/e-learning/ongoing/assignment",
		assignment: "/e-learning/assignment-history",
		certificate: "/e-learning/certificate",
		reminderTemplate: "/e-learning/reminder-template",
	},

	settings: {
		companyLogo: "/settings/company-logo",
		scheduler: "/settings/scheduler",
		emailTemplates: "/settings/email-templates",
	},

	forgotPassword: {
		resetPassword: "/forgot-password",
		verifyResetEmail: "/forgot-password/verify-email",
	},
};

export default pathnames;
